import { registerBlockType } from "@wordpress/blocks";
import React from "react";
import config, { type BlockAttributes } from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import { useBlockProps, useInnerBlocksProps } from "@wordpress/block-editor";
import HeaderSave from "./HeaderSave";
import HeaderEditor from "./HeaderEditor";
import { SVG, Path } from "@wordpress/components";

registerBlockType<BlockAttributes>(config.name, {
  ...config,
  icon() {
    return (
      <SVG viewBox="0 0 24 24">
        <Path d="M5 20.5a2 2 0 0 1-2-2V15a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2ZM4.5 15v3.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5Zm10.969 3.03-2-2 1.06-1.061L16 16.439l1.47-1.47 1.061 1.061-2 2a.751.751 0 0 1-1.061 0ZM6 17.5V16h6.5v1.5ZM5 11a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V9a2 2 0 0 1-2 2Zm-.5-5.5V9a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5.5A.5.5 0 0 0 19 5H5a.5.5 0 0 0-.5.5Zm10.97 3.03-2-2 1.06-1.06L16 6.939l1.47-1.469 1.06 1.06-2 2a.751.751 0 0 1-1.061 0ZM6 8V6.5h6.5V8Z" />
      </SVG>
    );
  },

  edit: HeaderEditor,
  save: HeaderSave,
});
